import { Component, Input, Output, EventEmitter, SimpleChange, Renderer2, OnDestroy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MaintenanceService } from '../../../../techopsv4/services/maintenanceService';
import { ExportDataService } from '../../../../shared';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DailogModalComponent } from '../../../../shared/elements/dailog-modal/dailog-modal.component';
import { ToastrService } from 'ngx-toastr';
import { CommonModelService } from '../../../../padu-reporting/capability/common-model.service';
import { ReplaySubject } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { MatTooltip } from '@angular/material/tooltip';
import { SharedAuthService } from '../../../../shared/shared.auth.service';
export interface LeaderNode {
  leader_level_1?: string;
  leader_level_1_msid?: string;
  leader_level_1_eid?: string;
  leader_level_2?: string;
  leader_level_2_msid?: string;
  leader_level_2_eid?: string;
  leader_level_3?: string;
  leader_level_3_msid?: string;
  leader_level_3_eid?: string;
  leader_level_4?: string;
  leader_level_4_msid?: string;
  leader_level_4_eid?: string;
  leader_level_5?: string;
  leader_level_5_msid?: string;
  leader_level_5_eid?: string;
  leader_level_6?: string;
  leader_level_6_msid?: string;
  leader_level_6_eid?: string;
  leader_level_7?: string;
  leader_level_7_msid?: string;
  leader_level_7_eid?: string;
  leader_level_8?: string;
  leader_level_8_msid?: string;
  leader_level_8_eid?: string;

  children?: LeaderNode[];
  selected?: boolean;
}

@Component({
  selector: 'app-optum-tech-labour',
  templateUrl: './optum-tech-labour.component.html',
  styleUrls: ['./optum-tech-labour.component.scss'],
  standalone: false
})
export class OptumTechLabourComponent implements OnDestroy {
  accessCheck: boolean; //false = normal user | true = FundingOwner, FundingDelegate, and FundingAdmin
  private clickListener: () => void;
  @ViewChild('otlLabor') otlLabor: ElementRef;
  private destroyed: ReplaySubject<boolean> = new ReplaySubject(1);
  public showLoader: boolean = false;
  leadersData: any;
  displayedColumns: string[];
  public ucmgArray = [];
  oldData: any;
  convertedData: any;
  capitalDemandLeaderResponse = []
  flattenedArr: any;
  filteredData: any;
  searchFilterText: string = '';
  selectedFilters: string[] = [];
  sort: any;
  currentFundingId: any;
  userAccessData: any;
  selectedRow: any = {};
  remainingOptumLabour: number;
  L1sTotalOT: number;
  addEditField: boolean;
  addLeaderFieldAccess: boolean;
  editMode: boolean = false;
  addLeaderButtonDisabled: boolean = true;
  TABLE_CONFIG: any = {
    pageSize: [10, 20, 40],
    pageIndex: 0,
    totalItems: 0,
    selection: false,
    edit: false,
    serverSidePagination: false,
    deleteFeature: true,
    expandable: false,
    isOptum: true
  };
  showHeirarchy: boolean = true;
  filteredDataForSb: LeaderNode[] = [];
  sbData: LeaderNode[] = [];
  searchText: string = '';
  OTLTextBox: string = '';
  expansionState = new Map<string, boolean>();
  selectedNodeId: string | null = null;
  selectedNode: any;
  existingNames: Set<string> = new Set();
  proposalReq: any;

  TABLE_COLUMNS: any = [
    {
      key: 'department_leader',
      labelKey: "department_leader",
      label: 'Department Leader',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': true }]
    },
    {
      key: 'department_Id',
      labelKey: "department_id_name",
      label: 'Department ID - Name',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': true }],
      align: 'center !important'
    },
    {
      key: 'Optum_Tech_Labour',
      labelKey: "optum_tech_labour",
      label: 'Optum Tech Labor',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': true }],
      align: 'center !important'
    },
    {
      key: 'roll_up_optum_tech',
      labelKey: "roll_up_optum_tech",
      label: 'Roll Up Optum Tech',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': true }],
      align: 'center !important'
    },
    {
      key: 'action',
      labelKey: "action",
      label: 'Action',
      addNew: false,
      filter: false,
      search: '',
      searchValue: '',
      edit: true,
      validations: [{ 'required': true }],
      align: 'center !important'
    }
  ];
  sortConfig = {
    active: 'Full_Name',
    direction: 'asc',
  }
  EditAction = {
    key: 'isEdit',
    label: 'Action'
  }
  DATA_SCHEMA = {
    "leader_name": "text",
    "optum_tech_labour": "text",
    "isEdit": 'isEdit'
  }
  @Output() optumPageRefresh = new EventEmitter<any>();
  @Output() dataRefresh: EventEmitter<any> = new EventEmitter();
  @Input() ucmgId;
  @Input() ucmgName;
  @Input() ucmgView;
  @Input() leadersDataLV;
  @Input() availableOTL;
  @Input() fundSegment;
  @Input() fiscalYear;
  @Input() investmentStatus;
  @Input() restrictionInvesterEdit;
  @Input() clearInputs;
  @Input() UCMG_Owner_MSID;
  isHierarchyMismatch: any;
  isOpenRequest: any;
  @Input() ucmgDisableData;
  @ViewChild('JustificationModal', { static: false }) JustificationModal;
  @ViewChild('deleteJustificationModal', { static: false }) deleteJustificationModal;
  dataSourceDetails: MatTableDataSource<any>;
  dataSourceDetailsOTLabor: MatTableDataSource<any>;

  expandCollapseAll: boolean = true; // Default to collapsed
  isfilterapplied: boolean = false;
  leaderNames: string[] = [];

  justificationTextfield: string = '';
  applyJustificationAction: string = '';
  applyJustificationUpdateBottomNode: any;
  mismatchLeadersMSIDs: any[] = [];
  isUCMGOwner: boolean = false;
  closedLeaderCommentsPopup: boolean = false;
  @ViewChild('leaderComments') leaderComments: any;
  comments: string = '';
  leaderCommentsSelectedElement: any = null;
  LEADER_COMMENTS_CONFIG: any = {
    pageSize: 0,
    pageIndex: 0,
    totalItems: 3,
    selection: true,
    edit: false,
    serverSidePagination: true,
    deleteFeature: true,
    expandable: false,
    innerTableEdit: false,
    isOptum: false
  };
  LEADER_COMMENTS_COLUMNS: any = [
    {
      key: 'User_Name',
      labelKey: "User_Name",
      label: 'User Name',
      width: '11.5% !important',
      padding: '5px 2px 5px 22px !important'
    },
    {
      key: 'Date',
      labelKey: "Date",
      label: 'Date',
      width: '13.8% !important',
      padding: '5px 2px 5px 3px !important'
    },
    {
      key: 'Comment',
      width: '13% !important',
      label: 'Comment',
      padding: '5px 5px 5px 0 !important'
    }
  ];
  leaderCommentsData: MatTableDataSource<any> = new MatTableDataSource([]);
  // yearList: any[] = [{name:new Date().getFullYear()}, {name: new Date().getFullYear() + 1}];
  currentTable: string = 'otl_leader_comments';
  isLeaderCommentsDataNull = false;
  leaderCommentsHeaderName: string = '';

  constructor(public maintenanceService: MaintenanceService, public dialog: MatDialog,
    private modelService: CommonModelService,
    private toaster: ToastrService,
    public exportService: ExportDataService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private router: Router,
   public sharedAuthService: SharedAuthService,) {
    //listen for Add Leader click to go away if we click outside the dropdown
    this.clickListener = this.renderer.listen('document', 'click', (event) => { this.onOutsideDropdownClick(event); });
  }

  onOutsideDropdownClick(event: MouseEvent) {
    //listen for Add Leader click to go away if we click outside the dropdown
    try {
      const targetElement = event.target as HTMLElement;
      const isClickInside = targetElement.closest('.tree') || targetElement.closest('.table-search') || targetElement.closest('.addLeaderWrapper');

      if (!isClickInside && !this.showHeirarchy) {
        this.clearSearch()
      }
    } catch (error) {
      console.log('Error handling dropdown click:', error);
    }
  }

  ngOnDestroy() {
    if (this.clickListener) {
      this.clickListener();
    }
  }

  ngOnInit() {
    this.getProposalTabSelectedOption();
    this.route.queryParams.subscribe(params => {
    });
    this.clearSearchAndOTLValues();
    this.getAccessDetails();
    this.calculateL1sOTTotal();
    this.getHierarachyList();
  }

  ngOnChanges() {
    this.expandCollapseAll = false; // Reset expand/collapse state on changes

    if (this.ucmgId) {
      this.clearSearchAndOTLValues();
      this.existingNames.clear();
      this.showHeirarchy = true;
      this.currentFundingId = this.fundSegment;
      this.getAccessDetails();
      this.getCapitalDemandLeaderList();
      this.searchFilterText = '';
      this.selectedFilters = [];
      this.isfilterapplied = false;
      this.leaderNames = [];
      this.getProposalTabSelectedOption();
    }
    if (this.ucmgDisableData && this.ucmgDisableData.hierarchyMismatch) {
      this.gethierarchyMismatchLeaderMSIDs();
    }

  }

  getLeaderName(node: LeaderNode): string {
    return node.leader_level_1 || node.leader_level_2 || node.leader_level_3 || node.leader_level_4 || node.leader_level_5 || node.leader_level_6 || node.leader_level_7 || node.leader_level_8 || '';
  }

  highlightText(text: string): string {
    if (!this.searchText) return text;
    const regex = new RegExp(`(${this.searchText})`, 'gi');
    return text.replace(regex, `<span class="highlight">$1</span>`);
  }

  toggleNode(node: LeaderNode) {
    const nodeId = this.getNodeId(node);
    this.expansionState.set(nodeId, !this.isExpanded(nodeId));
  }

  isExpanded(nodeId: string): boolean {
    return this.expansionState.get(nodeId) ?? false;
  }


  getNodeId(node: any): string {
    return (
      node.leader_level_1_msid ||
      node.leader_level_2_msid ||
      node.leader_level_3_msid ||
      node.leader_level_4_msid ||
      node.leader_level_5_msid ||
      node.leader_level_6_msid ||
      node.leader_level_7_msid ||
      node.leader_level_8_msid || ''
    );
  }

  filterTree() {
    this.filteredDataForSb = JSON.parse(JSON.stringify(this.sbData));
    if (this.searchText === '') {
      this.resetSearchState();
      return;
    }
    this.filteredDataForSb = this.filterNodes(this.filteredDataForSb, this.searchText.toLowerCase());
    this.expansionState.clear();
    this.expandMatchingNodes(this.filteredDataForSb);
  }

  resetSearchState() {
    this.selectedNode = null;
    this.showHeirarchy = true;
    this.filteredDataForSb = JSON.parse(JSON.stringify(this.sbData));
  }

  filterNodes(nodes: LeaderNode[], searchText: string): LeaderNode[] {
    this.showHeirarchy = false;
    return nodes.map(node => this.filterNode(node, searchText)).filter(node => node !== null);
  }

  filterNode(node: LeaderNode, searchText: string): LeaderNode | null {
    const isMatch = this.getLeaderName(node).toLowerCase().includes(searchText);
    const newNode = { ...node };

    if (isMatch) {
      newNode.children = node.children || [];
      return newNode;
    }

    newNode.children = node.children ? this.filterNodes(node.children, searchText) : [];
    return newNode.children.length > 0 ? newNode : null;
  }

  expandMatchingNodes(nodes: LeaderNode[]) {
    nodes.forEach(node => this.expandNode(node));
  }

  expandNode(node: LeaderNode) {
    this.expansionState.set(this.getNodeId(node), true);
    if (node.children) {
      this.expandMatchingNodes(node.children);
    }
  }

  clearSearch() {
    this.isOpenRequest = false;
    this.searchText = '';
    this.selectedNode = null;
    this.showHeirarchy = true;
    this.filteredDataForSb = [];
    this.expansionState.clear();
    this.addLeaderButtonDisabled = true;
  }

  onSelectNode(node: LeaderNode) {
    if (this.isDisabled(node))
      return;

    this.isOpenRequestForNode(node);
    const nodeId = this.getNodeId(node);
    this.selectedNodeId = this.selectedNodeId === nodeId ? null : nodeId;
    this.selectedNode = node;
    const key = Object.keys(this.selectedNode);
    this.searchText = node[key[0]];
    this.showHeirarchy = true;
    this.checkIfAddButtonIsDisabled();
  }

  isSelected(node: LeaderNode): boolean {
    return this.getNodeId(node) === this.selectedNodeId;
  }

  isDisabled(node: LeaderNode): boolean {

    //leader already has allocation in the table.
    const nodeName = this.getLeaderName(node);
    const isL1orL2 = !!node.leader_level_1 || !!node.leader_level_2;
    const existsInTable = this.existingNames.has(nodeName)
    return isL1orL2 || existsInTable
  }

  isLeafNode(node: LeaderNode): boolean {
    const isL1orL2 = !!node.leader_level_1 || !!node.leader_level_2;
    return !isL1orL2
  }

  isDisabledForHierarchyMismatch(node: LeaderNode) {
    this.isHierarchyMismatch = false; //reset hierarchy mismatch state

    // Check if ucmgDisableData has hierarchyMismatch content
    if (!this.ucmgDisableData.hierarchyMismatch || this.ucmgDisableData.hierarchyMismatch.length === 0) {
      this.isHierarchyMismatch = false;
    }

    let isPresent = false;
    //with leader event get data of cur node and compare to array of hierarchyMismatch
    this.ucmgDisableData.hierarchyMismatch.forEach(request => {
      //compare curnode to request leader
      if (node.leader_level_3_msid === request.L3_Leader_msid) {
        //if match then set isPresent to true
        isPresent = true;
      }
    });

    //if isPresent is true, set isOpenRequest to true
    //if not, there is no open request for this leader, set to false
    if (isPresent) { this.isHierarchyMismatch = true; } else { this.isHierarchyMismatch = false; }
  }

  isOpenRequestForNode(node: LeaderNode) {
    this.isOpenRequest = false; //reset open request state

    let leaderIsPresent = false;
    //for each open req in ucmgDisableData
    this.ucmgDisableData.openRequests.forEach(request => {
      //compare curnode to request leader
      if (node.leader_level_3_msid === request.L3_Leader_msid) {
        //if match then set leaderIsPresent to true
        leaderIsPresent = true;
        //get the req id
        this.proposalReq = request;
      }

      //if leaderIsPresent is true, set isOpenRequest to true
      //if not, there is no open request for this leader, set to false
      if (leaderIsPresent) { this.isOpenRequest = true; } else { this.isOpenRequest = false; }
    });
  }

  extractNames(data: any[]): void {
    for (const item of data) {
      Object.keys(item).forEach((key) => {
        if (key.startsWith('Leader_L') && key.endsWith('_Name')) {
          this.existingNames.add(item[key]);
        }
      });
      if (item.children?.length) {
        this.extractNames(item.children)
      }
    }
  }

  clearSearchAndOTLValues() {
    this.isOpenRequest = false;
    this.searchText = "";
    this.selectedNode = null;
    this.OTLTextBox = "";
    if (this.editMode == true) {
      this.editMode = false;
    }
  }

  getHierarachyList() {
    this.maintenanceService.getHierarchyList().subscribe(res => {
      this.sbData = res;
      this.filteredDataForSb = JSON.parse(JSON.stringify(this.sbData));
    }, err => {
      console.error(err);
      this.toaster.error('Error fetching hierarchy list', '', {
          timeOut: 10000,
          positionClass: 'toast-top-center'
        });
    });
  }

  // code for search box ends


  tablePaginationEvent(event) {
    if (event) {
      if (event.sort) {
        this.sort = event.sort;
      }
      this.TABLE_CONFIG['pageSize'] = event.pageSize;
      this.TABLE_CONFIG['pageIndex'] = event.pageIndex;
    }
  }


  checkBoxEvent(e) {
    this.selectedRow = e;
  }

  clearRollUpOTData(): any {
    this.convertedData.forEach(heir => this.clearRollUpForHeirarchy(heir));
  }

  private clearRollUpForHeirarchy(heir: any[]): void {
    heir.forEach(leader => {
      if (leader?.roll_up_optum_tech) {
        delete leader.roll_up_optum_tech;
      }
    });
  }


  addRollUpOTToData(): any {
    if (!this.convertedData || !Array.isArray(this.convertedData)) {
      console.error('convertedData is not initialized or is not an array');
      return this.convertedData;
    }
    this.convertedData.forEach((heirIndex, index) => {
      //calculate roll up per heirarchy
      this.calculateRollUpLabor(index, 0);
    });
    return this.convertedData;
  }




  calculateRollUpLabor(heirIndex: any, index: any) {
    if (!this.isValidConvertedData(heirIndex, index)) return;

    const currentLeader = this.convertedData[heirIndex][index];

    if (this.hasOptumTechLabor(currentLeader)) {
      return parseFloat(currentLeader.Optum_Tech_Labour);
    }

    if (this.hasRollUpOptumTech(currentLeader)) {
      return parseInt(currentLeader.roll_up_optum_tech);
    }

    return this.calculateRollUpFromChildren(heirIndex, index, currentLeader);
  }

  private isValidConvertedData(heirIndex: any, index: any): boolean {
    if (!this.convertedData || !Array.isArray(this.convertedData)) {
      console.error('convertedData is not initialized or is not an array');
      return false; // Return false for invalid input
    }
    if (!this.convertedData[heirIndex] || !this.convertedData[heirIndex][index]) {
      return false; // Return false if the specified heirIndex or index is invalid
    }
    return true;
  }

  private hasOptumTechLabor(leader: any): boolean {
    return leader?.Optum_Tech_Labour && leader.Optum_Tech_Labour !== '';
  }

  private hasRollUpOptumTech(leader: any): boolean {
    return leader?.roll_up_optum_tech;
  }



  private calculateRollUpFromChildren(heirIndex: any, index: any, leader: any): number {

    const leadLevel = this.getLevelInt(leader.level);
    leader.roll_up_optum_tech = 0;

    this.processChildren(heirIndex, index, leadLevel, leader);
    return leader.roll_up_optum_tech;
  }

  private processChildren(heirIndex: any, index: number, leadLevel: number, leader: any): void {
    let i = index + 1;

    while (this.shouldProcessChild(heirIndex, i, leadLevel)) {
      this.processChild(heirIndex, i, leadLevel, leader);
      i++;
    }
  }



  private processChild(heirIndex: any, i: number, leadLevel: number, leader: any): void {
    const curLevel = this.getLevelInt(this.convertedData[heirIndex][i].level);

    if (this.isGrandchild(leadLevel, curLevel)) {
      return;
    }

    leader.roll_up_optum_tech += this.calculateRollUpLabor(heirIndex, i);
  }

  private shouldProcessChild(heirIndex: any, i: number, leadLevel: number): boolean {
    return (
      i < this.convertedData[heirIndex].length &&
      this.getLevelInt(this.convertedData[heirIndex][i].level) !== leadLevel &&
      this.getLevelInt(this.convertedData[heirIndex][i].level) > leadLevel
    );
  }

  private isGrandchild(leadLevel: number, curLevel: number): boolean {
    return curLevel > leadLevel + 1;
  }


  getLevelInt(level) {
    if (!level || typeof level !== 'string') {
      console.error('Invalid level format:', level);
      return -1; // Return -1 for invalid input
    }
    // Extract the numeric part of the level string
    const levelNumber = parseInt(level.slice(1), 10);
    // Check if the extracted number is a valid integer
    if (isNaN(levelNumber)) {
      throw new Error("Invalid level format");
    }
    return levelNumber;
  }


  filterHierarchyData(dataArr) {
    //always show L1 Leaders
    let level1leaders_show = dataArr;
    level1leaders_show = dataArr.filter(row => row.leader_level === 1);
    //show L2 if L1 isExpand
    const filteredLevel2Leaders = dataArr.filter(item => {
      return item.leader_level === 2 && level1leaders_show.some(leader => leader.sub_ordinate === item.department_leader);
    });
    const result = [
      ...level1leaders_show,
      ...filteredLevel2Leaders
    ];
    return result;
  }


  getProcessedData(data) {
    const result = [];
    let currentArray = [];
    data.forEach(item => {
      if (item.Level === "L1") {
        if (currentArray.length > 0) {
          result.push(currentArray);
          currentArray = [];
        }
      }
      currentArray.push({
        ...item,
      });
    });
    if (currentArray.length > 0) {
      result.push(currentArray);
    }
    return result;
  }



  toggleExpanded(element: any) { 
    const groupIndex = this.convertedData.findIndex(group =>
      group.some(item =>
        item.Leader_Name === element.Leader_Name &&
        item.DepartmentIDName === element.DepartmentIDName &&
        item.level === element.level
      )
    );

    if (groupIndex === -1) {
      console.log("Element not found");
      return;
    }

    const group = this.convertedData[groupIndex];
    const itemIndex = group.findIndex(item =>
      item.Leader_Name === element.Leader_Name &&
      item.DepartmentIDName === element.DepartmentIDName &&
      item.level === element.level
    );

    const item = group[itemIndex];
    item.expanded = !item.expanded;

    if (element.level === 'L1' && !item.expanded) {
      this.collapseChildren(group, itemIndex, element.level);
    }

    this.filteredData = this.getFilteredData(this.convertedData);
    this.dataSourceDetailsOTLabor = new MatTableDataSource(this.filteredData);
    this.expandCollapseAll = this.convertedData.some(group =>
      group.some(leader => leader.expanded)
    );
  }

  collapseChildren(group: any[], startIndex: number, parentLevel: string) {
    const parentLevelInt = this.getLevelInt(parentLevel);
    for (let j = startIndex + 1; j < group.length; j++) {
      const childLevelInt = this.getLevelInt(group[j].level);
      if (childLevelInt > parentLevelInt) {
        group[j].expanded = false;
      } else {
        break;
      }
    }
  }



  getFilteredData(currentData) { 
    if (!Array.isArray(currentData)) {
      console.error('Invalid input provided to getFilteredData:', currentData);
      return [];
    }

    const levelOrder = ['L1', 'L2', 'L3', 'L4', 'L5', 'L6', 'L7', 'L8'];

    return currentData.map(group => {
      if (!Array.isArray(group)) {
        console.error('Invalid group in currentData:', group);
        return [];
      }

      const filteredGroup = [];
      const levelFlags = {};

      group.forEach(item => {
        const levelIndex = levelOrder.indexOf(item.level);
        if (levelIndex === -1) return;

        const parentLevel = levelOrder[levelIndex - 1];
        const shouldInclude = levelIndex === 0 || levelFlags[parentLevel];

        if (shouldInclude) {
          filteredGroup.push(item);
          levelFlags[item.level] = item.expanded;
        } else {
          levelFlags[item.level] = false;
        }
      });

      return filteredGroup;
    });

  }


  shouldShowExpandIcon(element: any): boolean {
    if (!element || !Array.isArray(this.convertedData)) {
      return false;
    }
    if (!this.convertedData) {
      return false;
    }
    let curElementIndex; //get index of curElement
    const curLevel = this.getLevelInt(element.level); //get level of curElement
    const deepCopy = this.convertedData;
    for (let i = 0; i < this.convertedData.length; i++) {
      curElementIndex = this.convertedData[i].findIndex((item: any) => item.Leader_Name === element.Leader_Name && item.department_id_name === element.department_id_name && item.level === element.level); //find current element
      if (curElementIndex !== -1) {
        const remainingElements = deepCopy[i].slice(curElementIndex + 1); //remove current item in tree and everything before
        if (!remainingElements || remainingElements.length === 0) { return false } //if nothing after return false
        if (this.getLevelInt(remainingElements[0].level) <= curLevel) {
          return false;
        } else {
          return true;
        }
      }
    }
    return false;
  }


  getAccessDetails() {
    let hasfundingAccess = this.sharedAuthService.getFundingAccessDetails('') || this.sharedAuthService.getFundingAccessDetails(this.fundSegment)

    if (hasfundingAccess) {
      this.accessCheck = true;
    } else {
      if(this.UCMG_Owner_MSID && this.UCMG_Owner_MSID === this.sharedAuthService.getMsid().toString()){
        this.accessCheck = true;
      } else {
        this.accessCheck = false;
      }
    }

    this.addEditField = true;
    this.addLeaderFieldAccess = true;
    if (this.restrictionInvesterEdit) {
      this.addEditField = true;
      this.addLeaderFieldAccess = true;
    } else {
      let segmentAccess = this.sharedAuthService.getFundingAccessDetails(this.fundSegment);
      if (segmentAccess) {
        this.addEditField = true;
        this.addLeaderFieldAccess = true;
      } else if (this.UCMG_Owner_MSID && this.UCMG_Owner_MSID === this.sharedAuthService.getMsid().toString()) { //make sure UCMG Owner has access
        this.addEditField = true;
        this.addLeaderFieldAccess = true;
        this.accessCheck = true;
      } else {
        this.addEditField = true;
        this.addLeaderFieldAccess = true;
        this.accessCheck = false;
      }
    }
    if (this.addEditField) {
      this.displayedColumns = ['department_leader','OT_Actuals','OT_Run_Rate', 'Optum_Tech_Labour', 'action'];
    } else {
      this.displayedColumns = ['department_leader', 'OT_Actuals','OT_Run_Rate', 'Optum_Tech_Labour'];
    }
  }



  addEditFieldToData(arr) { 
    if (!Array.isArray(arr)) {
      console.error('Input data is not an array:', arr);
      return arr;
    }

    arr.forEach(group => {
      if (!Array.isArray(group)) {
        console.error('Group is not an array:', group);
        return;
      }

      this.processGroupForEdit(group);
    });

    this.filteredData = this.getFilteredData(arr);
    return arr;
  }

  private processGroupForEdit(group: any[]) {
    let curParent = { level: null, msid: null};
    let prevNode;
    group.forEach((leader, index) => {

      if(prevNode) {
        if(this.getLevelInt(prevNode.level) === 1 || this.getLevelInt(prevNode.level) < this.getLevelInt(leader.level)) {
          curParent = { level: prevNode.level, msid: prevNode.Leader_MSID};
        }
      }

      leader.canEdit = false;

      const isLast = index === group.length - 1;
      const nextLeader = group[index + 1];
      const hasNoChildren = isLast || (nextLeader && (nextLeader.level) <= (leader.level));

      if (hasNoChildren) {
        leader.canEdit = true;

        const leaderMSIDs = this.findLeaderPathByLevelConcat(
          this.capitalDemandLeaderResponse,
          leader.level,
          leader.Leader_MSID,
          curParent?.level,
          curParent?.msid
        );

        if (
          leaderMSIDs &&
          this.mismatchLeadersMSIDs.length > 0 &&
          this.mismatchLeadersMSIDs.includes(leaderMSIDs)
        ) {
          leader.isHierarchyMismatch = true;
        }
      }
      prevNode = leader;
    });
  }


  findLeaderPathByLevelConcat(
    data: any,
    targetLevel: string,
    targetMSID: string,
    expectedParentLevel?: string | null,
    expectedParentMSID?: string | null
  ): string | null {
    let result: string[] = [];

    const expectedParentLevelNumber = (() => {
      if (!expectedParentLevel || typeof expectedParentLevel !== 'string') return null;
      return this.getLevelInt(expectedParentLevel);
    })();

    function matchesExpectedParent(path: string[], currentLevel: number): boolean {
      if (!expectedParentMSID) return true;

      if (
        expectedParentLevelNumber &&
        expectedParentLevelNumber >= 1 &&
        expectedParentLevelNumber < currentLevel
      ) {
        return path[expectedParentLevelNumber - 1] === expectedParentMSID;
      }

      // Fallback: assume caller means immediate parent.
      return path.length >= 2 && path[path.length - 2] === expectedParentMSID;
    }

    function traverse(node: any, level: number, path: string[]): boolean {
      const levelKey = `Leader_L${level}_MSID`;
      if (node[levelKey]) {
        path.push(node[levelKey]);
        if (
          node[levelKey] === targetMSID &&
          `L${level}` === targetLevel &&
          matchesExpectedParent(path, level)
        ) {
          result = [...path];
          return true;
        }
      }

      if (node.children && node.children.length > 0) {
        for (const child of node.children) {
          const newPath = [...path];
          if (traverse(child, level + 1, newPath)) {
            return true;
          }
        }
      }

      return false;
    }

    for (const l1 of data) {
      if (traverse(l1, 1, [])) {
        break;
      }
    }

    return result.length > 0 ? result.join(' ') : null;
  }




  addExpandedField(data) {
    if (!Array.isArray(data)) {
      console.error('Invalid input provided to addExpandedField:', data);
      return data; // Return the input as-is if it's not an array
    }
    return data.map(group => {
      if (!Array.isArray(group)) {
        console.error('Invalid group in data:', group);
        return group; // Return the group as-is if it's not an array
      }

      return group.map(leader => {
        return {
          ...leader,
          expanded: false
        };
      });
    });

  }


  findDirectLeaders(tree, target) {
    let treeDeepCopy = this.deepCopyTree(tree);
    let nodeWithParentReferences = null;

    function searchTree(node, parent) {
      //children is empty, return
      if (!node || !target) {
        return;
      }

      const targetKey = Object.keys(target).find(key => key.startsWith('leader_level_'));
      const nodeKey = Object.keys(node).find(key => key.startsWith('leader_level_'));

      node.children.forEach(child => {
        child.parent = node; // Set parent for the child node
      });

      //if target is found
      let isLeader3 = Object.keys(node).some(key => key.startsWith('leader_level_3'));
      if (node[nodeKey] === target[targetKey] && isLeader3) {
        nodeWithParentReferences = node;
      } else if (node.children && node.children.length > 0) { //if not the target, but has children, keep searching
        node.children.forEach((child) => searchTree(child, node));
      }
    }

    treeDeepCopy.forEach(root => searchTree(root, null));

    function extractLeaders(node: any): any[] {
      const leaders = [];

      // Traverse up the hierarchy using the parent property
      while (node) {
        // Add the current node to the leaders list
        leaders.push(node);

        // Move to the parent node
        if (node.parent) {
          node = node.parent;
          node.children = [];
        } else {
          break;
        }
      }

      // Reverse the list to ensure the hierarchy starts from L1
      return leaders.reverse();
    }

    const leaders = extractLeaders(nodeWithParentReferences);
    return leaders;
  }

  flattenTree(tree) {
    if (!tree || !Array.isArray(tree)) {
      console.error('Invalid input provided to flattenTree:', tree);
      return [];
    }
    const flatArray = [];

    function flatten(node, level) {
      const newNode = { ...node, level: level };
      delete newNode.children;
      flatArray.push(newNode);

      if (node.children && node.children.length > 0) {
        node.children.forEach(child => flatten(child, level + 1));
      }
    }

    tree.forEach(root => flatten(root, 1));
    return flatArray;
  }

  getLevelFromKey(node) {
    const keys = Object.keys(node);
    for (const key of keys) {
      const match = key.match(/leader_level_(\d+)/);
      if (match) {
        return parseInt(match[1], 10);
      }
    }
    return -1; // Return -1 if no level key is found
  }


  AddNewEntry() {
    let payload = {
      "UCMG_ID": this.ucmgId,
      "UCMG_Name": this.ucmgName,
      "fiscalYear": this.fiscalYear,
      "Leader_Level": "L" + this.getLevelFromKey(this.selectedNode),
      Optum_Tech_Labour: this.OTLTextBox,
      Leader_Name: this.selectedNode[`leader_level_${this.getLevelFromKey(this.selectedNode)}`],
      Leader_msid: this.selectedNode[`leader_level_${this.getLevelFromKey(this.selectedNode)}_msid`],
    }

    //populate leader msid, name, eid fields for payload
    let leaders = this.findDirectLeaders(this.sbData, this.selectedNode);
    leaders.forEach((leader, index) => {
      let level = index + 1; // L1, L2, L3, etc.
      payload[`Leader_L${level}_MSID`] = leader[`leader_level_${level}_msid`];
      payload[`Leader_L${level}_Name`] = leader[`leader_level_${level}`];
      payload[`Leader_L${level}_EmployeeId`] = leader[`leader_level_${level}_eid`];
    });
   this.setConvertedDataToStorage(this.convertedData);
    this.maintenanceService.postCapitalDemandUCMGLeader(payload).subscribe({
      next: (res) => {
        if (res.status === 400) {
          this.toaster.error('Internal Server Error.', '', { timeOut: 10000, positionClass: 'toast-top-center' });
          console.log(res)
          console.log('ERROR Adding Leader response');
        } else {
          this.toaster.success("Successfully added leader", '', { timeOut: 10000, positionClass: 'toast-top-center' });
          console.log(res, 'Success Add Leader response');
          this.addLeaderButtonDisabled = true;
          this.dataRefreshAfterSave();
          this.getCapitalDemandLeaderList();
          this.clearLocalFilter();
          this.clearSearchAndOTLValues();
        }
      },
      error: (err) => {
        if (err) {
          this.toaster.error('Internal Server Error.', '', { timeOut: 10000, positionClass: 'toast-top-center' });
          console.log('ERROR Adding Leader response');
        }
      }
    });
  }

  checkIfAddButtonIsDisabled() {
    if (!!this.selectedNode && !!this.OTLTextBox) {
      this.addLeaderButtonDisabled = false;
      return;
    }
    this.addLeaderButtonDisabled = true;
  }

  getCapitalDemandLeaderList() {
    this.showLoader = true;
    this.filteredData = [];
    this.convertedData = [];
    this.dataSourceDetailsOTLabor = new MatTableDataSource([]);
    this.clearSelectedElements();
    this.existingNames.clear();
    if (!this.ucmgId || !this.fiscalYear) {
      return;
    }

    const payload = {
      "UCMG_ID": this.ucmgId,
      "fiscalYear": this.fiscalYear
    }
    let response = []
    this.maintenanceService.listCapitalDemandUCMGList(payload, 4).subscribe((result: any) => {
      if (result.LeaderData) {
        response = result.LeaderData || [];
        this.capitalDemandLeaderResponse = result.LeaderData; //save for later use
        //for search box comparison
        this.extractNames(response);
        const newArr = []
        response.forEach(element => {
          const arrWrapper = [];
          arrWrapper.push(element);
          newArr.push(arrWrapper);
        });
        this.flattenedArr = [];
        const finalArray = [];
        for (let i = 0; i < newArr.length; i++) {
          //for some reason a wierd case of an array with an obj with null values is coming in, just skip it
          const obj = newArr[i];
          if (obj[0].Leader_L1_Name === null && obj[0].Leader_L1_MSID === null && obj[0].children.length === 0) {
            continue;
          }//end of weird edge case
          finalArray.push(this.transformData(newArr[i], 1));
        }
        this.convertedData = finalArray;
        this.convertedData = this.addExpandedField(this.convertedData);// add expand on each leader so we can add this functionality
        this.convertedData = this.addEditFieldToData(this.convertedData); // add edit field to leader to see if it should be editable
        this.calculateL1sOTTotal();
        this.getDistinctLeaderNames();
        this.oldData = this.convertedData;
        const savedData = this.getConvertedDataFromStorage();
        if (savedData) {
          // Index saved leaders by MSID for fast lookup
          const savedLeaderMap = new Map();
          savedData.flat().forEach(saved => {
            if (saved && saved.Leader_MSID) {
              savedLeaderMap.set(saved.Leader_MSID, saved);
            }
          });
          this.convertedData.forEach(group => {
            group.forEach(leader => {
              const savedLeader = savedLeaderMap.get(leader.Leader_MSID);
              if (savedLeader && typeof savedLeader.expanded === 'boolean') {
                leader.expanded = savedLeader.expanded;
              }
            });
          });
          this.expandCollapseAll = this.convertedData.some(group => group.some(leader => leader.expanded));
        }
        this.filteredData = this.getFilteredData(this.convertedData);
        this.dataSourceDetailsOTLabor = new MatTableDataSource(this.filteredData);
        sessionStorage.removeItem('convertedData');
        if(this.ucmgView === 'leaderView'){
          if (this.leadersDataLV && this.leadersDataLV.length > 0) {
            this.selectedFilters = [this.leadersDataLV[this.leadersDataLV.length - 1].Leader];
          } else {
            this.selectedFilters = [];
          }    
          this.applyLocalFilter();
          
        }
      }
      this.showLoader = false;
    })
  }

  // helper functions

  getConvertedDataFromStorage() {
    if (sessionStorage.getItem('convertedData')) {
      return JSON.parse(sessionStorage.getItem('convertedData') || '{}');
    }
    return null;
  }

  setConvertedDataToStorage(data) {
    sessionStorage.setItem('convertedData', JSON.stringify(data));
  }

  transformData(arr, curLevel) { //input an array of leaders
    if (!Array.isArray(arr)) {
      console.error('Input data is not an array or is null/undefined:', arr);
      return arr === null ? null : arr === undefined ? undefined : [];
    }
    //"Flatten" out each L1 Heirarchy
    let levelList = [];
    arr.forEach((leader, index) => { //array of leaders (Current Level Leaders)
      levelList = levelList.concat(this.transformDataHelper(leader, curLevel)); //return heirarchys
    });
    return levelList;
  }

  transformDataHelper(obj, curLevel) {
    const curHeirarchyList = [];
    let Leader_Name;
    let Leader_MSID;

    //get Leader_Name
    const key = `Leader_L${curLevel}_Name`;
    if (obj[key]) {
      Leader_Name = obj[key];
    } else {
      Leader_Name = ''
    }
    //get Leader MSID
    const key2 = `Leader_L${curLevel}_MSID`;
    if (obj[key2]) {
      Leader_MSID = obj[key2];
    } else {
      Leader_MSID = ''
    }

    const jsonObj = {
      "Leader_Name": Leader_Name,
      "Leader_MSID": Leader_MSID,
      "level": "L" + curLevel,
      "department_id_name": obj.department_id_name || '',
      "Optum_Tech_Labour": obj.Optum_Tech_Labour || '',
      "Actuals": obj.Actuals || '',
      "Run_Rate": obj.Run_Rate || '',
      "totalActuals": obj.totalActuals || 0,
      "totalRunRate": obj.totalRunRate || 0,
      "edit": false
    }

    curHeirarchyList.push(jsonObj);

    if (Array.isArray(obj.children) && obj.children.length > 0 && obj.children.length !== 0) {
      return curHeirarchyList.concat(this.transformData(obj.children, curLevel + 1))
    }

    return curHeirarchyList;
  }

  convertToString(value: any): string {
    return value.toString();
  }

  exportToCsv() {
    //TODO need to make dynamic
    if (this.dataSourceDetailsOTLabor.data && this.dataSourceDetailsOTLabor.data.length) {


      const exportData = this.processLeadersForExcel(this.convertedData);
      const dataValues = [];
      exportData.forEach((ele, index) => {
        const obj: any = {};
        obj['Leader L1 Name'] = ele['Leader_L1_Name'] ? ele['Leader_L1_Name'] : '';
        obj['Leader L1 MSID'] = ele['Leader_L1_MSID'] ? ele['Leader_L1_MSID'] : '';
        obj['Leader L2 Name'] = ele['Leader_L2_Name'] ? ele['Leader_L2_Name'] : '';
        obj['Leader L2 MSID'] = ele['Leader_L2_MSID'] ? ele['Leader_L2_MSID'] : '';
        obj['Leader L3 Name'] = ele['Leader_L3_Name'] ? ele['Leader_L3_Name'] : '';
        obj['Leader L3 MSID'] = ele['Leader_L3_MSID'] ? ele['Leader_L3_MSID'] : '';
        obj['Leader L4 Name'] = ele['Leader_L4_Name'] ? ele['Leader_L4_Name'] : '';

        obj['Leader L4 MSID'] = ele['Leader_L4_MSID'] ? ele['Leader_L4_MSID'] : '';
        obj['Leader L5 Name'] = ele['Leader_L5_Name'] ? ele['Leader_L5_Name'] : '';

        obj['Leader L5 MSID'] = ele['Leader_L5_MSID'] ? ele['Leader_L5_MSID'] : '';
        obj['Leader L6 Name'] = ele['Leader_L6_Name'] ? ele['Leader_L6_Name'] : '';

        obj['Leader L6 MSID'] = ele['Leader_L6_MSID'] ? ele['Leader_L6_MSID'] : '';
        obj['Leader L7 Name'] = ele['Leader_L7_Name'] ? ele['Leader_L7_Name'] : '';
        obj['Leader L7 MSID'] = ele['Leader_L7_MSID'] ? ele['Leader_L7_MSID'] : '';
        obj['Leader L8 Name'] = ele['Leader_L8_Name'] ? ele['Leader_L8_Name'] : '';
        obj['Leader L8 MSID'] = ele['Leader_L8_MSID'] ? ele['Leader_L8_MSID'] : '';
        obj['OT Labour'] = ele['Optum_Tech_Labour'] ? ele['Optum_Tech_Labour'] : '';
        obj['OT Actuals'] = this.roundForExport(ele['Actuals'] || ele['totalActuals']);
        obj['OT Run Rate'] = this.roundForExport(ele['Run_Rate'] || ele['totalRunRate']);
        dataValues.push(obj);
      });
      const fileName = 'Optum Tech Labor Split';
      this.exportService.exportToExcel(fileName, [dataValues], ['Optum Tech Labor Split View']);
    }
  }

  private roundForExport(value: any): number | '' {
    const amount = Number(value);
    return value === null || value === undefined || value === '' || !Number.isFinite(amount)
      ? ''
      : Math.round(amount);
  }


  processLeadersForExcel(data) {
    if (!Array.isArray(data)) {
      console.error('Invalid input provided to processLeadersForExcel:', data);
      return [];
    }

    const result = [];

    data.forEach((L1Hierarchy) => {
      let L1: any, L2: any, L3: any, L4: any, L5: any, L6: any, L7: any, L8: any;

      for (let i = 0; i < L1Hierarchy.length; i++) {
        const current = L1Hierarchy[i];
        const next = L1Hierarchy[i + 1];

        switch (current.level) {
          case "L1":
            L1 = current;
            break;
          case "L2":
            L2 = current;
            break;
          case "L3":
            L3 = current;
            if (L1Hierarchy[i + 1] == undefined || L1Hierarchy[i + 1].level === "L3" || L1Hierarchy[i].level === "L3") {
              result.push(this.excelRow(L1, L2, L3, L4, L5, L6, L7, L8, current.Optum_Tech_Labour, current.Actuals, current.Run_Rate, current.totalActuals, current.totalRunRate));
            }
            break;
          case "L4":
            L4 = current;
            if (L1Hierarchy[i + 1] == undefined || L1Hierarchy[i + 1].level === "L4") {
              result.push(this.excelRow(L1, L2, L3, L4, L5, L6, L7, L8, current.Optum_Tech_Labour, current.Actuals, current.Run_Rate, current.totalActuals, current.totalRunRate));
            }
            break;
          case "L5":
            L5 = current;
            if (L1Hierarchy[i + 1] == undefined || L1Hierarchy[i + 1].level === "L5") {
              result.push(this.excelRow(L1, L2, L3, L4, L5, L6, L7, L8, current.Optum_Tech_Labour, current.Actuals, current.Run_Rate, current.totalActuals, current.totalRunRate));
            }
            break;
          case "L6":
            L6 = current;
            if (L1Hierarchy[i + 1] == undefined || L1Hierarchy[i + 1].level === "L6") {
              result.push(this.excelRow(L1, L2, L3, L4, L5, L6, L7, L8, current.Optum_Tech_Labour, current.Actuals, current.Run_Rate, current.totalActuals, current.totalRunRate));
            }
            break;
          case "L7":
            L7 = current;
            if (L1Hierarchy[i + 1] == undefined || L1Hierarchy[i + 1].level === "L7") {
              result.push(this.excelRow(L1, L2, L3, L4, L5, L6, L7, L8, current.Optum_Tech_Labour, current.Actuals, current.Run_Rate, current.totalActuals, current.totalRunRate));
            }
            break;
          case "L8":
            L8 = current;
            result.push(this.excelRow(L1, L2, L3, L4, L5, L6, L7, L8, current.Optum_Tech_Labour, current.Actuals, current.Run_Rate, current.totalActuals, current.totalRunRate));
            break;
        }
      }
    });

    return result;
  }
showDeletebutton: boolean = false;
selectedElementsForDelete: any[] = [];

onCheckboxChange(event: any) {
  
  // Check if the event has the required properties
  if (!event || typeof event.isChecked === 'undefined' ) {
    console.warn('Invalid event object passed to onCheckboxChange');
    return;
  }
  
  const element = event;
  const isChecked = event.isChecked;
  
  if (isChecked) {
    // Add element to selected array if checked and not already present
    const existingIndex = this.selectedElementsForDelete.findIndex(item => 
      item.Leader_Name === element.Leader_Name && 
      item.Leader_MSID === element.Leader_MSID && 
      item.level === element.level
    );
    
    if (existingIndex === -1) {
      this.selectedElementsForDelete.push({
        Leader_Name: element.Leader_Name,
        Leader_MSID: element.Leader_MSID,
        level: element.level,
        department_id_name: element.department_id_name,
        Optum_Tech_Labour: element.Optum_Tech_Labour,
        Actuals: element.Actuals,
        Run_Rate: element.Run_Rate
      });
    }
  } else {
    // Remove element from selected array if unchecked
    this.selectedElementsForDelete = this.selectedElementsForDelete.filter(item => 
      !(item.Leader_Name === element.Leader_Name && 
        item.Leader_MSID === element.Leader_MSID && 
        item.level === element.level)
    );
  }
  
  // Show delete button if any elements are selected
  this.showDeletebutton = this.selectedElementsForDelete.length > 0;
  
}

clearSelectedElements() {
  this.selectedElementsForDelete = [];
  this.showDeletebutton = false;
}

getSelectedElementsCount(): number {
  return this.selectedElementsForDelete.length;
}

bulkDeleteSelectedElements() {
  if (this.selectedElementsForDelete.length === 0) {
    console.warn('No elements selected for deletion');
    return;
  }

  this.setConvertedDataToStorage(this.convertedData);
  const dialogConfig = this.getBulkDeleteDialogConfig();
  const dialogRef = this.dialog.open(DailogModalComponent, dialogConfig);
  
  dialogRef.afterClosed().subscribe(result => {
    if (result && result.data === 'save') {
      this.handleBulkDelete();
    }
  });
}

getBulkDeleteDialogConfig(): MatDialogConfig {
  const count = this.selectedElementsForDelete.length;
  const title = count === 1 
    ? 'Are you sure to delete the selected Leader?' 
    : `Are you sure to delete the ${count} selected Leaders?`;
    
  return {
    width: '400px',
    hasBackdrop: true,
    minHeight: '200px',
    height: 'auto',
    disableClose: true,
    autoFocus: false,
    data: {
      title: title,
      buttonName: 'Delete',
      isOptum: true
    }
  };
}


  excelRow(L1: any, L2: any, L3: any, L4: any, L5: any, L6: any, L7: any, L8: any, otl: number, actuals: number, runRate: number, totalActuals: number, totalRunRate: number) {
    return {
      Optum_Tech_Labour: otl || "",
      Actuals: actuals || "",
      Run_Rate: runRate || "",
      totalActuals: totalActuals || 0,
      totalRunRate: totalRunRate || 0,
      Leader_L1_Name: L1.Leader_Name || "",
      Leader_L1_MSID: L1.Leader_MSID || "",
      Leader_L2_Name: L2.Leader_Name || "",
      Leader_L2_MSID: L2.Leader_MSID || "",
      Leader_L3_Name: L3.Leader_Name || "",
      Leader_L3_MSID: L3.Leader_MSID || "",
      Leader_L4_Name: L4 ? L4.Leader_Name : "",
      Leader_L4_MSID: L4 ? L4.Leader_MSID : "",
      Leader_L5_Name: L5 ? L5.Leader_Name : "",
      Leader_L5_MSID: L5 ? L5.Leader_MSID : "",
      Leader_L6_Name: L6 ? L6.Leader_Name : "",
      Leader_L6_MSID: L6 ? L6.Leader_MSID : "",
      Leader_L7_Name: L7 ? L7.Leader_Name : "",
      Leader_L7_MSID: L7 ? L7.Leader_MSID : "",
      Leader_L8_Name: L8 ? L8.Leader_Name : "",
      Leader_L8_MSID: L8 ? L8.Leader_MSID : ""
    }
  }


  editOTL(element: any) {
    if (!element) {
      console.warn('editOTL called with undefined element');
      return;
    }
    this.editMode = !this.editMode;
    element.edit = !element.edit;
    if (element.edit) {
      element.stashOTL = element.Optum_Tech_Labour;
      this.otlLabor = element.stashOTL;
    } else {
      {
        element.Optum_Tech_Labour = element.stashOTL;
        this.calculateRemainingOnpressEditAction(element);
      }
    }
    this.cdr.detectChanges();
  }

  editOTLreqAlloc(element: any) {
    if (!element) {
      console.warn('Invalid element passed to editOTLreqAlloc:', element);
      return;
    }

    this.editMode = !this.editMode;
    element.edit = !element.edit;
    if (element.edit) {
      element.stashOTL = element.Optum_Tech_Labour;
      this.otlLabor = element.stashOTL;
    } else {
      {
        element.Optum_Tech_Labour = element.stashOTL;
        this.calculateRemainingOnpressEditAction(element);
      }
    }
    this.cdr.detectChanges();
  }

  saveOTL(element: any, index: any) {
    if (!Array.isArray(this.convertedData)) {
      console.warn('convertedData is not properly initialized');
      return;
    }

    if (parseInt(element?.Optum_Tech_Labour) === element?.stashOTL) {
      this.toaster.error('Please make a change the OTL value before updating', '', { timeOut: 10000, positionClass: 'toast-top-center' });
      return;
    }

    //send API
    let saveElementIndex;
    let arrayReference;
    // Save the converted data to local storage
    this.setConvertedDataToStorage(this.convertedData);
    this.convertedData.forEach((heir, arrIndex) => {
      heir.forEach((leader, leaderIndex) => {
        if (leader.Leader_Name == element.Leader_Name && leader.level == element.level) {
          saveElementIndex = leaderIndex;
          arrayReference = arrIndex;
        }
      });
    });
    const curLevel = this.getLevelInt(element.level);

    const payload = {
      "UCMG_ID": this.ucmgId,
      "fiscalYear": this.fiscalYear,
      "Optum_Tech_Labour": element.Optum_Tech_Labour,
      "Leader_Level": element.level,
    }
    const curLeaderMSIDKey = `Leader_L${curLevel}_MSID`;
    payload[curLeaderMSIDKey] = element.Leader_MSID;
    const higherLeaders = [];
    higherLeaders.push(element.level)
    for (let i = saveElementIndex - 1; i >= 0; i--) {
      //if item is not a leader above
      if (!higherLeaders.includes(this.convertedData[arrayReference][i].level)) {
        const itemLevel = this.convertedData[arrayReference][i].level;
        higherLeaders.push(itemLevel)
        const keyMSID = `Leader_L${this.getLevelInt(itemLevel)}_MSID`;
        payload[keyMSID] = this.convertedData[arrayReference][i].Leader_MSID;
      }
    }

    this.maintenanceService.putCapitalDemandUCMGLeader(payload).subscribe({
      next: (res) => {
        if (res.Message == "Capital Demand Leader updated successfully.") {
          this.toaster.success("Successfully edited leader", '', { timeOut: 10000, positionClass: 'toast-top-center' });
          console.log(res, 'Success Editing Leader');
          this.dataRefreshAfterSave()
          this.calculateL1sOTTotal();
          this.getCapitalDemandLeaderList();
          this.clearLocalFilter()
          this.editMode = false;
          element.edit = false;
          delete element.stashOTL;
          this.dataRefreshAfterSave()
          this.cdr.detectChanges();
        } else {
          this.toaster.error('Internal Server Error.', '', { timeOut: 10000, positionClass: 'toast-top-center' });
          console.log("ERROR Editing Leader");
        }
      },
      error: (err) => {
        this.toaster.error('Internal Server Error.', '', { timeOut: 10000, positionClass: 'toast-top-center' });
        console.log(err);
        console.log("ERROR Editing Leader");
      }
    });
  }


  deleteLeader(element) {
    this.setConvertedDataToStorage(this.convertedData);
    const dialogConfig = this.getDialogConfig();
    const dialogRef = this.dialog.open(DailogModalComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.showLoader = true;
      if (result && result.data === 'save') {
        this.handleDelete(element);
      }
      this.showLoader = false;
    });
  }

  getDialogConfig(): MatDialogConfig {
    return {
      width: '400px',
      hasBackdrop: true,
      minHeight: '200px',
      height: 'auto',
      disableClose: true,
      autoFocus: false,
      data: {
        title: 'Are you sure to delete the selected Leader?',
        buttonName: 'Delete',
        isOptum: true
      }
    };
  }

  handleDelete(element: any) {
    this.showLoader = true;
    this.deleteAPI(element);
    this.removeElementFromHierarchy(element);
    this.calculateL1sOTTotal();
    this.showLoader = false;
  }

  handleBulkDelete() {
    if (this.selectedElementsForDelete.length === 0) {
      console.warn('No elements selected for deletion');
      return;
    }

    this.showLoader = true;
    // Use the same deleteAPI but with bulk payload
    this.deleteAPI(this.selectedElementsForDelete, true);
  }

  removeElementFromHierarchy(element: any) {
    if (!Array.isArray(this.convertedData)) {
      console.error('convertedData is undefined or not an array');
      this.showLoader = false;
      return;
    }
    for (let i = 0; i < this.convertedData.length; i++) {
      const index = this.convertedData[i].findIndex(item =>
        item.Leader_Name === element.Leader_Name &&
        item.department_id_name === element.department_id_name &&
        item.level === element.level
      );

      if (index !== -1) {
        this.processHierarchyDeletion(i, index);
        break;
      }
    }
  }

  processHierarchyDeletion(groupIndex: number, elementIndex: number) {
    this.convertedData[groupIndex].splice(elementIndex, 1);
    this.removeParentIfNecessary(groupIndex, elementIndex - 1);
  }

  removeParentIfNecessary(groupIndex: number, parentIndex: number) {
    while (parentIndex >= 0) {
      const parent = this.convertedData[groupIndex][parentIndex];
      const child = this.convertedData[groupIndex][parentIndex + 1];

      if (!child || this.getLevelInt(child.level) <= this.getLevelInt(parent.level)) {
        this.convertedData[groupIndex].splice(parentIndex, 1);
        parentIndex--;
      } else {
        break;
      }
    }
  }

  deleteAPI(element: any, isBulk?: boolean) {
    if (isBulk && Array.isArray(element)) {
      // Handle bulk deletion
      this.handleBulkAPICall(element);
    } else {
      // Handle single deletion
      this.handleSingleAPICall(element);
    }
  }

  handleSingleAPICall(element: any) {
    if (!element || !element.Leader_MSID || !this.ucmgId || !this.fiscalYear) {
      console.error('Invalid element or missing required properties:', element);
      return;
    }
    const payload = this.buildDeletePayload(element);
    this.maintenanceService.deleteCapitalDemandUCMGLeader(payload).subscribe({
      next: res => this.handleDeleteSuccess(res),
      error: err => this.handleDeleteError(err)
    });
  }

  handleBulkAPICall(elements: any[]) {
    const bulkPayload = [];
    
    // Build payload for each element
    elements.forEach(element => {
      if (element && element.Leader_MSID && this.ucmgId && this.fiscalYear) {
        const elementPayload = {
          UCMG_ID: this.ucmgId,
          fiscalYear: parseInt(this.fiscalYear),
          Leader_Level: element.level,
          Req_Justification1: this.justificationTextfield,
          Req_generated_From: 'Techops_UI',
          created_by: this.cleanCreatedBy(sessionStorage.getItem('currentUser')),
          created_by_Id: this.sharedAuthService.getMsid()
        };
        
        // Add current leader MSID
        const curLevel = this.getLevelInt(element.level);
        const curLeaderMSIDKey = `Leader_L${curLevel}_MSID`;
        elementPayload[curLeaderMSIDKey] = element.Leader_MSID;
        
        // Add higher level leaders
        this.addHigherLeadersToPayload([elementPayload], element, curLevel);
        
        bulkPayload.push(elementPayload);
      }
    });

    if (bulkPayload.length === 0) {
      console.error('No valid elements for bulk deletion');
      this.showLoader = false;
      return;
    }

    // Send bulk payload
    this.maintenanceService.deleteCapitalDemandUCMGLeader(bulkPayload).subscribe({
      next: res => this.handleBulkDeleteSuccess(res, elements.length),
      error: err => this.handleBulkDeleteError(err)
    });
  }

  buildDeletePayload(element: any): any {
    const payload = [{
      UCMG_ID: this.ucmgId,
      fiscalYear: parseInt(this.fiscalYear),
      Leader_Level: element.level,
      Req_Justification1: this.justificationTextfield,
      Req_generated_From: 'Techops_UI',
      created_by: this.cleanCreatedBy(sessionStorage.getItem('currentUser')),
      created_by_Id: this.sharedAuthService.getMsid()
    }];

    const curLevel = this.getLevelInt(element.level);
    const curLeaderMSIDKey = `Leader_L${curLevel}_MSID`;
    payload[0][curLeaderMSIDKey] = element.Leader_MSID;

    this.addHigherLeadersToPayload(payload[0], element, curLevel);
    return payload;
  }

  addHigherLeadersToPayload(payload: any, element: any, curLevel: number) {
    if (!Array.isArray(this.convertedData)) {
      console.error('Invalid convertedData:', this.convertedData);
      return;
    }
    const higherLeaders = [element.level];
    let deleteElementIndex;
    let arrayReference;

    this.convertedData.forEach((heir, arrIndex) => {
      heir.forEach((leader, leaderIndex) => {
        if (leader.Leader_Name === element.Leader_Name && leader.level === element.level) {
          deleteElementIndex = leaderIndex;
          arrayReference = arrIndex;
        }
      });
    });

    if (deleteElementIndex === undefined || arrayReference === undefined) {
      console.error('Element not found in convertedData');
      return;
    }

    for (let i = deleteElementIndex - 1; i >= 0; i--) {
      if (!higherLeaders.includes(this.convertedData[arrayReference][i].level)) {
        const itemLevel = this.convertedData[arrayReference][i].level;
        higherLeaders.push(itemLevel);
        const keyMSID = `Leader_L${this.getLevelInt(itemLevel)}_MSID`;
        payload[keyMSID] = this.convertedData[arrayReference][i].Leader_MSID;
      }
    }
  }

  handleDeleteSuccess(res: any) {
    if (res.Message === 'Capital Demand Leader(s) deleted successfully.' || res.Message === 'Capital Demand Leader deleted successfully.') {
      this.toaster.success('Successfully deleted leader', '', { timeOut: 10000, positionClass: 'toast-top-center' });
      this.dataRefreshAfterSave();
      this.getCapitalDemandLeaderList();
      this.clearLocalFilter();
    } else {
      this.toaster.error('Internal Server Error.', '', { timeOut: 10000, positionClass: 'toast-top-center' });
    }
  }

  handleDeleteError(err: any) {
    this.toaster.error('Internal Server Error.', '', { timeOut: 10000, positionClass: 'toast-top-center' });
    console.error(err);
  }

  handleBulkDeleteSuccess(res: any, totalCount: number) {
    this.showLoader = false;
    
    // Remove elements from local hierarchy
    this.selectedElementsForDelete.forEach(element => {
      this.removeElementFromHierarchy(element);
    });
    
    // Recalculate totals
    this.calculateL1sOTTotal();
    
    const message = totalCount === 1 
      ? 'Successfully deleted leader' 
      : `Successfully deleted ${totalCount} leaders`;
      
    this.toaster.success(message, '', { timeOut: 10000, positionClass: 'toast-top-center' });
    
    // Refresh data and clear selections
    this.dataRefreshAfterSave();
    this.getCapitalDemandLeaderList();
    this.clearLocalFilter();
    this.clearSelectedElements();
  }

  handleBulkDeleteError(err: any) {
    this.showLoader = false;
    this.toaster.error('Failed to delete selected leaders', '', { timeOut: 10000, positionClass: 'toast-top-center' });
    console.error(err);
  }

  calculateL1sOTTotal() {
    if (this.convertedData === undefined) { return; }
    this.L1sTotalOT = 0;
    //for each arr
    this.clearRollUpOTData()
    this.addRollUpOTToData()
    this.convertedData.forEach((heir: any) => {
      heir.forEach((leader: any) => {
        if (leader.level == "L1") {
          this.L1sTotalOT += leader.roll_up_optum_tech;
        }
      });
    });
    this.remainingOptumLabour = this.availableOTL - (this.L1sTotalOT);
  }

  calculateRemainingOnpressEditAction(element) {
    if (!element || !element.Optum_Tech_Labour) {
      console.error('Invalid element passed to calculateRemainingOnpressEditAction:', element);
      return;
    }
    if (!Array.isArray(this.convertedData)) {
      console.error('convertedData is not properly initialized');
      return;
    }
    const elementOTLChange = element.Optum_Tech_Labour;

    //need update element OTL to elementOTLChange in temp arr
    this.convertedData.forEach((heir: any) => {
      heir.forEach((leader: any) => {
        //if cur element
        if (leader.level === element.level && leader.Leader_MSID === element.Leader_MSID) {
          leader.Optum_Tech_Labour = elementOTLChange;
        }
      });
    });
    this.calculateL1sOTTotal();
  }

  calculateRemainingOnpressOTL(otl) {
    this.calculateL1sOTTotal()
    this.cdr.detectChanges();
    if (otl === '') {
      return;
    }
    this.remainingOptumLabour -= parseInt(otl);
    this.cdr.detectChanges();
  }

  validateIntegerInput(event: KeyboardEvent) {
    const charCode = event.charCode;
    let allowNegative = false;
    if (this.availableOTL < 0) {
      allowNegative = true;
    } else {
      allowNegative = false;
    }
    //if not a valid int (not counting negative sign) dont let it be typed
    if ((charCode < 48 && charCode != 45) || charCode > 57 || (allowNegative == false && charCode == 45)) { // Only allow digits (0-9) and - if remainingOTL is -
      event.preventDefault();
    }
  }

  dataRefreshAfterSave() {
    this.dataRefresh.emit(true);
  }

  expandAll() {
    this.expandCollapseAll = true;
    this.convertedData.forEach(group => {
      group.forEach(leader => leader.expanded = true);
    });
    this.filteredData = this.getFilteredData(this.convertedData);
  }

  collapseAll() {
    this.expandCollapseAll = false;
    this.convertedData.forEach(group => {
      group.forEach(leader => leader.expanded = false);
    });
    this.filteredData = this.getFilteredData(this.convertedData);
  }

  isMatchingNode = (node, selectedFilters) => {
    return selectedFilters.some(selectedLeader =>
      Object.keys(node).some(key =>
        key.startsWith('Leader_L') &&
        key.endsWith('_Name') &&
        node[key]?.toLowerCase() === selectedLeader.toLowerCase()
      )
    );
  };



  applyLocalFilter() {  
    if (!this.selectedFilters || this.selectedFilters.length === 0) {
      console.log('No filters selected, clearing local filter.');
      this.clearLocalFilter();
      return;
    }

    const filterHierarchy = (nodes) => {
      return nodes
        .map(node => {
          if (this.isMatchingNode(node, this.selectedFilters)) {
            return node;
          }

          if (node.children && node.children.length > 0) {
            const filteredChildren = filterHierarchy(node.children);
            if (filteredChildren.length > 0) {
              return { ...node, children: filteredChildren };
            }
          }

          return null;
        })
        .filter(node => node !== null);
    };


    const filteredHierarchy = filterHierarchy(this.capitalDemandLeaderResponse);

    this.isfilterapplied = true;

    // Update the filteredData with the filtered hierarchy
    const newArr = []
    filteredHierarchy.forEach(element => {
      const arrWrapper = [];
      arrWrapper.push(element);
      newArr.push(arrWrapper);
    });
    this.flattenedArr = [];
    const finalArray = [];
    for (let i = 0; i < newArr.length; i++) {
      //for some reason a wierd case of an array with an obj with null values is coming in, just skip it
      const obj = newArr[i];
      if (obj[0].Leader_L1_Name === null && obj[0].Leader_L1_MSID === null && obj[0].children.length === 0) {
        continue;
      }//end of weird edge case
      finalArray.push(this.transformData(newArr[i], 1));
    }
    this.filteredData = finalArray;


    this.filteredData = this.addEditFieldToData(this.filteredData);
    this.filteredData = this.getFilteredData(this.filteredData);

    this.filteredData = finalArray.map(group => {
      return group.map(leader => {
        return {
          ...leader,
          expanded: true
        };
      });
    });

    this.convertedData = this.filteredData;
    this.calculateL1sOTTotal();
    this.expandCollapseAll = this.convertedData.some(group => group.some(leader => leader.expanded));
    this.dataSourceDetailsOTLabor = new MatTableDataSource(this.filteredData);
    this.cdr.detectChanges();
  }

  clearLocalFilter() {
    this.searchFilterText = '';
    this.selectedFilters = [];
    // Ensure convertedData is defined
    if (!Array.isArray(this.convertedData)) {
      this.convertedData = [];
    }
    this.convertedData.forEach(group => {
      group.forEach(leader => {
        leader.expanded = false;
      });
    });
    this.isfilterapplied = false;
    this.convertedData = this.oldData || [];
    this.expandCollapseAll = this.convertedData.some(group => group.some(leader => leader.expanded));

    this.filteredData = this.filteredData = this.getFilteredData(this.convertedData);
  }

  getDistinctLeaderNames() {
    this.convertedData.forEach(group => {
      group.forEach(leader => {
        if (leader.Leader_Name && !this.leaderNames.includes(leader.Leader_Name)) {
          this.leaderNames.push(leader.Leader_Name);
        }
      });
    });

  }

  requestAllocation(action: string, element?: any) {
    const validActions = ["Add", "Update", "Delete"];
    if (!validActions.includes(action)) {
      console.error(`Invalid action: ${action}`);
      return;
    }
    if (action !== "Add" && (!element || typeof element !== "object")) {
      console.error(`Invalid element passed for action "${action}":`, element);
      return;
    }

    this.justificationTextfield = '';
    if (action === "Update") {
      if (parseInt(element?.Optum_Tech_Labour) === element?.stashOTL) {
        this.toaster.error('Please make a change the OTL value before updating', '', { timeOut: 10000, positionClass: 'toast-top-center' });
        return;
      }
    }
    this.applyJustificationUpdateBottomNode = element;
    if (action !== "Add") {
      this.applyJustificationUpdateBottomNode.proposedOTL = element?.Optum_Tech_Labour ? parseInt(element?.Optum_Tech_Labour) : 0;
    }
    this.applyJustificationAction = action;
    //justification popup
    if (action === "Delete") {
      this.deleteJustificationModal.show();
    } else {
      this.JustificationModal.show();
    }
  }

  applyJustification() {
    if (!this.justificationTextfield || this.justificationTextfield.trim() === '') {
      this.toaster.error('Justification text is required', '', {
        timeOut: 10000,
        positionClass: 'toast-top-center',
      });
      return;
    }
    switch (this.applyJustificationAction) {
      case "Add":
        this.addAllocationProposal();
        break;

      case "Update":
        if (this.applyJustificationUpdateBottomNode.Optum_Tech_Labour === this.applyJustificationUpdateBottomNode.stashOTL) {
          this.toaster.error('Please make a change the OTL value before updating', '', { timeOut: 10000, positionClass: 'toast-top-center' });
          return;
        }
        //element update off
        this.applyJustificationUpdateBottomNode.edit = false;
        //reset element stash and otl
        this.applyJustificationUpdateBottomNode.Optum_Tech_Labour = this.applyJustificationUpdateBottomNode.stashOTL; //reset OTL to stash
        this.applyJustificationUpdateBottomNode.stashOTL = undefined; //remove stash
        //calc leaders
        this.calculateRemainingOnpressEditAction(this.applyJustificationUpdateBottomNode);
        this.updateAllocationProposal();
        break;

      case "Delete":
        this.deleteAllocationProposal();
        break;

      default:
        console.error(`Unknown action: ${this.applyJustificationAction}`);
        break;
    }
    this.JustificationModal.hide();
  }

  applyDeleteJustification() {
    this.deleteAllocationProposal();
    this.deleteJustificationModal.hide();
  }

  addAllocationProposal() {

    this.showLoader = true;
    let payload = {
      "UCMG_Id": this.ucmgId,
      "Proposed_OT_Labor": this.OTLTextBox,
      "preProposed_OT_Labor": null,
      "fisclYr": parseInt(this.fiscalYear),
      "Req_Justification1": this.justificationTextfield,
      "Req_generated_From": "Techops_UI",
      "created_by": this.cleanCreatedBy(sessionStorage.getItem('currentUser')),
      "created_by_Id": this.sharedAuthService.getMsid()
    };

    //populate leader msid field for payload
    let leaders = this.findDirectLeaders(this.sbData, this.selectedNode);
    leaders.forEach((leader) => {
      const curLeaderLevel = this.getLevelFromKey(leader);
      const curLeaderMSID = `leader_level_${curLeaderLevel}_msid`;
      payload[`L${curLeaderLevel}_Leader_msid`] = leader[curLeaderMSID];
    });

    this.maintenanceService.capitalDemandAddAllocation(payload).subscribe(res => {
      this.toaster.success('Successfully created add request allocation', '', { timeOut: 10000, positionClass: 'toast-top-center' });
      this.postUCMGDisableCheck(this.ucmgId);
    }, err => {
      console.log(err);
      this.toaster.error('Internal Server Error.', '', { timeOut: 10000, positionClass: 'toast-top-center' });
    });

    //clear inputs
    this.justificationTextfield = ''; //clear justification textfield
    this.clearSearchAndOTLValues();
    this.addLeaderButtonDisabled = true; //disable add button
    this.showLoader = false;
  }

  updateAllocationProposal() {

    this.showLoader = true;
    if (!this.applyJustificationUpdateBottomNode || !this.applyJustificationUpdateBottomNode.Leader_MSID) {
      console.error('applyJustificationUpdateBottomNode or Leader_MSID is undefined:', this.applyJustificationUpdateBottomNode);
      this.showLoader = false;
      return;
    }

    if (!Array.isArray(this.convertedData) || this.convertedData.length === 0) {
      console.error('convertedData is undefined or empty:', this.convertedData);
      this.showLoader = false;
      return;
    }
    let curNode = this.applyJustificationUpdateBottomNode;
    const leaderMSID = this.applyJustificationUpdateBottomNode.Leader_MSID;
    const proposed_OTL = this.applyJustificationUpdateBottomNode.proposedOTL;
    const stash_OTL = this.applyJustificationUpdateBottomNode.stashOTL;
    let payload = {
      "UCMG_Id": this.ucmgId,
      "fisclYr": parseInt(this.fiscalYear),
      "Proposed_OT_Labor": proposed_OTL,
      "preProposed_OT_Labor": this.applyJustificationUpdateBottomNode.Optum_Tech_Labour,
      "Req_Justification1": this.justificationTextfield,
      "Req_generated_From": "Techops_UI",
      "created_by": this.cleanCreatedBy(sessionStorage.getItem('currentUser')) || '',
      "created_by_Id": this.sharedAuthService.getMsid() || ''
    };

    let updateElementIndex;
    let arrayReference;
    this.convertedData.forEach((heir, arrIndex) => {
      heir.forEach((leader, leaderIndex) => {
        if (leader.Leader_Name === curNode.Leader_Name && leader.level === curNode.level) {
          updateElementIndex = leaderIndex;
          arrayReference = arrIndex;
        }
      });
    });

    if (updateElementIndex === undefined || arrayReference === undefined) {
      console.error('Element not found in convertedData:', curNode);
      this.showLoader = false;
      return;
    }

    const curLevel = this.getLevelInt(curNode.level);
    const higherLeaders = [];
    const curLeaderMSIDKey = `L${curLevel}_Leader_msid`;
    payload[curLeaderMSIDKey] = curNode.Leader_MSID;
    higherLeaders.push(curNode.level)
    for (let i = updateElementIndex - 1; i >= 0; i--) {
      //if item is not a leader above
      if (!higherLeaders.includes(this.convertedData[arrayReference][i].level)) {
        const itemLevel = this.convertedData[arrayReference][i].level;
        higherLeaders.push(itemLevel)
        const keyMSID = `L${this.getLevelInt(itemLevel)}_Leader_msid`;
        payload[keyMSID] = this.convertedData[arrayReference][i].Leader_MSID;
      }
    }


    this.maintenanceService.capitalDemandUpdateAllocation(payload).subscribe(res => {
      this.toaster.success('Successfully created updated allocation request', '', { timeOut: 10000, positionClass: 'toast-top-center' });
      this.postUCMGDisableCheck(this.ucmgId);
    }, err => {
      this.toaster.error('Internal Server Error.', '', { timeOut: 10000, positionClass: 'toast-top-center' });
    });

    //clear inputs
    this.convertedData[arrayReference][updateElementIndex].edit = false; //set edit to false
    this.justificationTextfield = ''; //clear justification textfield
    this.showLoader = false;
  }

  deleteAllocationProposal() {

    this.showLoader = true;

    if (!Array.isArray(this.convertedData)) {
      console.warn('convertedData is not properly initialized');
      this.showLoader = false;
      return;
    }

    let curNode = this.applyJustificationUpdateBottomNode;
    let payload = {
      "UCMG_Id": this.ucmgId,
      "fisclYr": parseInt(this.fiscalYear),
      "preProposed_OT_Labor": this.applyJustificationUpdateBottomNode.Optum_Tech_Labour,
      "Req_Justification1": this.justificationTextfield,
      "Req_generated_From": "Techops_UI",
      "created_by": this.cleanCreatedBy(sessionStorage.getItem('currentUser')),
      "created_by_Id": this.sharedAuthService.getMsid()
    };

    let deleteElementIndex;
    let arrayReference;
    this.convertedData.forEach((heir, arrIndex) => {
      heir.forEach((leader, leaderIndex) => {
        if (leader.Leader_Name == curNode.Leader_Name && leader.level == curNode.level) {
          deleteElementIndex = leaderIndex;
          arrayReference = arrIndex;
        }
      });
    });

    const curLevel = this.getLevelInt(curNode.level);
    const higherLeaders = [];
    const curLeaderMSIDKey = `L${curLevel}_Leader_msid`;
    payload[curLeaderMSIDKey] = curNode.Leader_MSID;
    higherLeaders.push(curNode.level)
    for (let i = deleteElementIndex - 1; i >= 0; i--) {
      //if item is not a leader above
      if (!higherLeaders.includes(this.convertedData[arrayReference][i].level)) {
        const itemLevel = this.convertedData[arrayReference][i].level;
        higherLeaders.push(itemLevel)
        const keyMSID = `L${this.getLevelInt(itemLevel)}_Leader_msid`;
        payload[keyMSID] = this.convertedData[arrayReference][i].Leader_MSID;
      }
    }

    this.maintenanceService.capitalDemandDeleteAllocation(payload).subscribe(res => {
      this.toaster.success('Successfully created delete allocation request', '', { timeOut: 10000, positionClass: 'toast-top-center' });
      this.postUCMGDisableCheck(this.ucmgId);
    }, err => {
      console.log(err);
      this.toaster.error('Internal Server Error.', '', { timeOut: 10000, positionClass: 'toast-top-center' });
    });

    //clear inputs
    this.justificationTextfield = ''; //clear justification textfield
    this.showLoader = false;
  }

  cleanCreatedBy(userName: string): string {
    if (!userName) return '';

    // Check if the string is already in the desired format
    const alreadyFormatted = /^[a-zA-Z]+, [a-zA-Z]+$/.test(userName.trim());
    if (alreadyFormatted) {
      return userName.trim();
    }

    // Remove leading/trailing quotes and spaces, then replace extra spaces around commas
    return userName.replace(/^["']|["']$/g, '').replace(/\s*,\s*/g, ', ').trim();
  }

  closeDeleteJustificationModal() {
    if (this.deleteJustificationModal && typeof this.deleteJustificationModal.hide() === 'function') {
      this.deleteJustificationModal.hide();
    }
  }

  deepCopyTree(obj: any, seen = new WeakMap()): any {
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }

    if (seen.has(obj)) {
      return seen.get(obj);
    }

    const copy = Array.isArray(obj) ? [] : {};
    seen.set(obj, copy);

    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        copy[key] = this.deepCopyTree(obj[key], seen);
      }
    }

    return copy;
  }

  leaderTooltipVisible: boolean = false;
  actionTooltipVisible: boolean = false;
  tooltipContent: string = '';
  addButtonTooltipX: number = 0;
  tooltipX: number = 0;
  tooltipY: number = 0;

  showTooltip(event: MouseEvent, content: string, type): void {
    if (type === 'leader') {
      this.leaderTooltipVisible = true;
    } else if (type === 'action') {
      this.actionTooltipVisible = true;
    }
    this.tooltipContent = content;
    this.addButtonTooltipX = event.clientX - 200; // Adjust X position
    this.tooltipX = event.clientX - 80; // Adjust X position
    this.tooltipY = event.clientY + 12; // Adjust Y position
  }

  hideTooltip(type): void {
    if (type === 'leader') {
      this.leaderTooltipVisible = false;
    } else if (type === 'action') {
      this.actionTooltipVisible = false;
    }
  }



  linkToProposal() {
    this.showRecord(this.proposalReq);
  }

  leaderHierMouseEnterTooltipLogic(node) {
    //check if node needs a tooltip
    let isLeafNode = false;
    if (this.isLeafNode(node)) {
      isLeafNode = true;
    }

    let isDisabledForHierarchyMismatch;
    this.isDisabledForHierarchyMismatch(node); //update isOpenRequest
    if (this.isOpenRequest) { isDisabledForHierarchyMismatch = true; } else { isDisabledForHierarchyMismatch = false; }

    let isDisabledForOTL;
    if (this.isDisabled(node)) { isDisabledForOTL = true; } else { isDisabledForOTL = false; }

    //update tooltip and returns

    if (isLeafNode && !this.isHierarchyMismatch && isDisabledForOTL) {
      this.tooltipContent = "This leader already has allocated OT, please use edit icon in Hierarchy.";
      return true;
    }

    if (isLeafNode && this.isHierarchyMismatch) {
      this.tooltipContent = "Leader Hierarchy is mismatched. Please contact Segment Owner or Delegate.";
      return true;
    }

    //nothing to add a tooltip for
    return false;
  }

  isOpenProposalUpdateDelete(node: any): boolean {
    let isPresent = false;
    if (!node || !this.ucmgDisableData) {
      return false;
    }

    this.ucmgDisableData.openRequests.forEach(request => {
      if (node.Leader_MSID === request.L3_Leader_msid) {
        isPresent = true;
      }
    });


    if (isPresent) { return true; } else { return false; }
  }

  routeToUpdateDeleteProposal(node: any) {
    let req = '';
    this.ucmgDisableData.openRequests.forEach(request => {
      if (node.Leader_MSID === request.L3_Leader_msid) {
        req = request;
      }
    });

    this.proposalReq = req;
    this.showRecord(this.proposalReq);
  }

  ifAddHasOpenReq() {
    return true;
  }

  getIsOpenRequest() {
    return this.isOpenRequest;
  }

  @ViewChild('modalRoot') modalRoot: any;
  @Output('reloadDataEvent') reloadDataEvent = new EventEmitter<any>();
  closedProposalPopup: boolean = false;
  proposalPopupSelectedOption: string = 'approvals';
  showRecord(reqID: any) {
    let element1 = <any>document.querySelector('.nav-color');
    if (element1) { element1.style.zIndex = 1; }
    this.closedProposalPopup = false;
    this.modalRoot.show();
  }

  onModalClose() {
    this.closedProposalPopup = true;
  }

  hidecancelpopup() {
    this.proposalReq = '';
    this.modalRoot.hide();
    this.reloadDataEvent.emit();
  }

  postUCMGDisableCheck(ucmgId: any) {
    let payload = {
      'UCMG_ID': ucmgId,
      'fisclYr': this.fiscalYear
    };
    this.maintenanceService.ucmgDisableCheck(payload).subscribe({
      next: (res) => {
        if (res.status === 400) {
          this.toaster.error('Internal Server Error.', '', { timeOut: 10000, positionClass: 'toast-top-center' });
          console.log(res)
          console.log('ERROR Adding Leader response');
        } else {
          this.ucmgDisableData = res;
          this.gethierarchyMismatchLeaderMSIDs();
          console.log('ucmgDisableCheck response:', res);
        }
      },
      error: (err) => {
        if (err) {
          this.toaster.error('Internal Server Error.', '', { timeOut: 10000, positionClass: 'toast-top-center' });
          console.log('ERROR Adding Leader response');
        }
      }
    });
  }
  gethierarchyMismatchLeaderMSIDs() {
    this.mismatchLeadersMSIDs = [];
    this.ucmgDisableData.hierarchyMismatch.forEach(mismatch => {
      const level = parseInt(mismatch.Leader_Level.replace(/\D/g, ''), 10);
      let allleaderMSIDs = '';
      for (let i = 1; i <= level; i++) {
        const keyMSID = `Leader_L${i}_MSID`;
        if (i != level) {
          allleaderMSIDs += mismatch[keyMSID] + ' ';
        } else {
          allleaderMSIDs += mismatch[keyMSID];
        }

      }
      this.mismatchLeadersMSIDs.push(allleaderMSIDs);
    });
  }

  getProposalTabSelectedOption() {

    let fundingAdmin = this.sharedAuthService.getFundingAccessDetails('');
    let segmentAccess = this.sharedAuthService.getFundingAccessDetails(this.fundSegment);
    if (fundingAdmin) {
      this.proposalPopupSelectedOption = 'approvals';
    } else if (segmentAccess) {
        //if delagate or owner AND they have access to ucmg then === make 'approvals'
        this.proposalPopupSelectedOption = 'approvals';
    } else {
      //if normal user === make 'requests'
      this.proposalPopupSelectedOption = 'requests';
    }
  }

  leaderCommentsOpen(element: any) {
    this.closedLeaderCommentsPopup = false;
    this.leaderCommentsHeaderName = element?.Leader_Name || '';
    this.comments = '';
    this.leaderCommentsSelectedElement = this.enrichLeaderCommentsElement(element);
    this.getLeaderCommentsAPI(this.leaderCommentsSelectedElement);
    this.leaderComments.show();
  }

  leaderCommentsClose() {
    this.leaderCommentsData.data = [];
    this.closedLeaderCommentsPopup = true;
  }

  enterLeaderHierComment() {
    // Intentionally keeping this local until the backend endpoint is wired.
    const comment = (this.comments || '').trim();
    if (!comment) {
      this.toaster.error('Comment is required', '', { timeOut: 10000, positionClass: 'toast-top-center' });
      return;
    }

    const userName = this.cleanCreatedBy(sessionStorage.getItem('currentUser')) || '';
    const date = new Date().toISOString().slice(0, 10);

    const newRow = {
      User_Name: userName,
      Date: date,
      Comment: comment,
      // Keep context available for future API wiring / debugging.
      ...this.leaderCommentsSelectedElement,
    };

    const existing = Array.isArray(this.leaderCommentsData?.data) ? this.leaderCommentsData.data : [];
    this.leaderCommentsData.data = [newRow, ...existing];
    // Trigger mat-table refresh.
    (this.leaderCommentsData as any)?._updateChangeSubscription?.();
    this.comments = '';
  }

  private enrichLeaderCommentsElement(element: any): any {
    if (!element || !element.level || !element.Leader_MSID) {
      return element;
    }

    const chain = this.buildLeaderChainFromConvertedData(element);
    return {
      ...element,
      ...chain,
    };
  }

  private buildLeaderChainFromConvertedData(element: any): any {
    const chain: any = {};

    // Always include the currently-selected leader.
    try {
      const curLevel = this.getLevelInt(element.level);
      if (curLevel >= 1) {
        chain[`Leader_L${curLevel}_MSID`] = element.Leader_MSID;
        chain[`Leader_L${curLevel}_Name`] = element.Leader_Name;
      }
    } catch {
      // Ignore malformed level strings.
    }

    if (!Array.isArray(this.convertedData)) {
      return chain;
    }

    // Find the element inside convertedData (same strategy used in saveOTL).
    let groupIndex = -1;
    let elementIndex = -1;

    outer: for (let gi = 0; gi < this.convertedData.length; gi++) {
      const group = this.convertedData[gi];
      if (!Array.isArray(group)) continue;
      for (let li = 0; li < group.length; li++) {
        const row = group[li];
        if (row?.Leader_MSID === element.Leader_MSID && row?.level === element.level) {
          groupIndex = gi;
          elementIndex = li;
          break outer;
        }
      }
    }

    if (groupIndex === -1 || elementIndex === -1) {
      return chain;
    }

    const group = this.convertedData[groupIndex];
    const seenLevels = new Set<string>();

    // Walk upward and capture one leader per level (L1..Ln).
    for (let i = elementIndex; i >= 0; i--) {
      const row = group[i];
      if (!row?.level || seenLevels.has(row.level)) continue;
      seenLevels.add(row.level);

      let levelNumber = -1;
      try {
        levelNumber = this.getLevelInt(row.level);
      } catch {
        continue;
      }

      if (levelNumber < 1) continue;
      chain[`Leader_L${levelNumber}_MSID`] = row.Leader_MSID;
      chain[`Leader_L${levelNumber}_Name`] = row.Leader_Name;
    }

    return chain;
  }

  getleaderCommentsData(){
    return this.leaderCommentsData;
  }

  LCDataRefresh(event){
    if(event){
      this.getleaderCommentsData();
    }
  }

  private getLeaderCommentsAPI(params: any) {
    let payload = {
      UCMG_ID: this.ucmgId,
      fiscalYear: parseInt(this.fiscalYear),
      Leader_L1_MSID: params.Leader_L1_MSID || null,
      Leader_L2_MSID: params.Leader_L2_MSID || null,
      Leader_L3_MSID: params.Leader_L3_MSID || null
    };
    try {
      this.maintenanceService.getHierarchyLeaderComments(payload).subscribe(res => {
        if(res[0]?.Comment1 === null && res[0]?.Comment2 === null && res[0]?.Comment3 === null){
          this.isLeaderCommentsDataNull = true;
        }
        this.leaderCommentsData = new MatTableDataSource(res);
      }, err => {
        console.error(err);
        this.toaster.error('Error fetching hierarchy list', '', {
            timeOut: 10000,
            positionClass: 'toast-top-center'
          });
      });
    } catch (error) {
      console.error('Unexpected error in getLeaderCommentsAPI:', error);
      this.toaster.error('ERROR getting Leader Hierarchy Comments.', '', {
        timeOut: 10000,
        positionClass: 'toast-top-center'
      });
    }
  }

  leaderCommentsAdd() {
    this.addLeaderCommentsAPI();
  }

  addLeaderCommentsAPI(){
    console.log('leaderCommentsData', this.leaderCommentsData);
    // where: { Leader_L1_MSID: p.Leader_L1_MSID, Leader_L2_MSID: p.Leader_L2_MSID, Leader_L3_MSID: p.Leader_L3_MSID, UCMG_ID: p.UCMG_ID, fisclYr: p.fiscalYear},
    let payload = {
      Leader_L1_MSID: this.leaderCommentsSelectedElement.Leader_L1_MSID || null,
      Leader_L2_MSID: this.leaderCommentsSelectedElement.Leader_L2_MSID || null,
      Leader_L3_MSID: this.leaderCommentsSelectedElement.Leader_L3_MSID || null,
      UCMG_ID: this.ucmgId,
      fiscalYear: parseInt(this.fiscalYear),
      comment1createdByName: this.cleanCreatedBy(sessionStorage.getItem('currentUser')),
      comment1createdBy: this.sharedAuthService.getMsid(),
      comment1createdAt: new Date().toISOString(),
      Comment1: this.comments,
    }

    this.maintenanceService.addHierarchyLeaderComments(payload).subscribe(res => {
      this.getLeaderCommentsAPI(this.leaderCommentsSelectedElement);
      this.comments = ''
    }, err => {
      console.error(err);
      this.toaster.error('Error adding leader hierarchy comment', '', {
          timeOut: 10000,
          positionClass: 'toast-top-center'
        });
    });
  }
}
